import {generateUrlGeoserverVector, hideLoading, showLoading} from "../core/utils";
import {MVTLayer} from "deck.gl";

export function simpleLayer(workspace, layerName) {

    const dataSource = generateUrlGeoserverVector(workspace, layerName)


    /*
const currentCatalog = 'public.xyz_query_entitity_attribute'
// const currentCatalog = 'xyz_query_buildings'
const currentVectorLayer = data['geometry_table']
const currentAttributeId = data['attr_id']
if (data['is_categorical']) {
    var currentRangeValue = [0, 20] // Should be between 0 and the number of categories-1
} else {
    var currentRangeValue = [data['value_q02'], data['value_q98']]
}

// &timeseries_index=${currentAttributeTimeseriesIndex}
*/


    return new MVTLayer({
        id: 'sumatra' + layerName,
        data: dataSource,
        onTileLoad: showLoading,
        onViewportLoad: hideLoading,
        // minZoom: 6,
        // maxZoom: 16,
        opacity: 1,
        stroked: true,
        filled: true,
        // extruded: true,
        // wireframe: false,
        // getLineColor: [0, 0, 255],
        getFillColor: [255, 255, 255, 0],
        // getLineColor: d => getColor(d, currentRangeValue, colorMapIndex, false),
        // getFillColor: d => getColor(d, currentRangeValue, 1, false),
        getLineWidth: 1.0,
        lineWidthMinPixels: 1.0,
        pointType: 'text',
        pickable: true,
        getElevation: 1,
        dataComparator: (a, b) => false
    });
}